<template>
  <div style="color:white">DIGLOJA ADMIN</div>
</template>
